import React, { useContext, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'
import { NavContext } from '../../contexts/nav-context'

const Menu: React.FC = () => {
	const { isNavMenuOpen, toggleNavMenu } = useContext(NavContext)

	useEffect(() => {
		let body = document.body
		isNavMenuOpen ? body.classList.add('no-scroll') : body.classList.remove('no-scroll')

		let navIcon = document.querySelector('.nav-icon') as HTMLDivElement
		isNavMenuOpen ? navIcon.classList.add('menu--clicked') : navIcon.classList.remove('menu--clicked')

		let navMenu = document.querySelector('.menu--container') as HTMLDivElement
		// isNavMenuOpen ? navMenu.classList.add('menu--container__shown') : navMenu.classList.remove('menu--container__shown')

		if (isNavMenuOpen) {
			navMenu.classList.add('menu--container__shown')
		} else {
			setTimeout(() => {
				navMenu.classList.remove('menu--container__shown')
			}, 500)
		}
	}, [isNavMenuOpen])

	const gifRef = useRef(null)
	const footerRef = useRef(null)
	const itemListOneRef = useRef(null)
	const itemListTwoRef = useRef(null)
	const itemListThreeRef = useRef(null)
	const navMenuLogoRef = useRef(null)

	useEffect(() => {
		let body = document.body
		let navMenuGif = document.querySelector('.nav-menu-gif') as HTMLImageElement
		if (body.offsetWidth < 700) {
			navMenuGif.src = '/images/menu/gif-med.gif'
		} else {
			navMenuGif.src = '/images/menu/gif-big.gif'
		}
	}, [])

	return (
		<div className='menu--container'>
			<CSSTransition nodeRef={gifRef} in={isNavMenuOpen} timeout={5000} classNames='slide'>
				<div ref={gifRef} className='menu--img'>
					<img className='nav-menu-gif' src='' alt='' />
					{/* <img src='/images/menu/menu-1.png' alt='' /> */}
				</div>
			</CSSTransition>

			<div className='menu--list'>
				<CSSTransition nodeRef={navMenuLogoRef} in={isNavMenuOpen} timeout={5000} classNames='fade-nav-logo'>
					<img ref={navMenuLogoRef} className='nav-50-menu' src='/images/mummy-at-50-logo.png' alt='' />
				</CSSTransition>

				<div>
					<CSSTransition nodeRef={itemListOneRef} in={isNavMenuOpen} timeout={5000} classNames='slide-item-one'>
						<a href='https://gratico.app/mummy-lillian' className='menu-item' onClick={toggleNavMenu} ref={itemListOneRef}>
							Event
						</a>
					</CSSTransition>

					<CSSTransition nodeRef={itemListTwoRef} in={isNavMenuOpen} timeout={5000} classNames='slide-item-two'>
						<Link to='/gallery' className='menu-item' onClick={toggleNavMenu} ref={itemListTwoRef}>
							Gallery
						</Link>
					</CSSTransition>

					<CSSTransition nodeRef={itemListThreeRef} in={isNavMenuOpen} timeout={5000} classNames='slide-item-three'>
						<a
							href='https://nlwc.church/about-us'
							target='_blank'
							className='menu-item'
							onClick={toggleNavMenu}
							rel='noreferrer'
							ref={itemListThreeRef}
						>
							About NLWC
						</a>
					</CSSTransition>
				</div>

				<CSSTransition nodeRef={footerRef} in={isNavMenuOpen} timeout={5000} classNames='slide-p'>
					<div className='menu--footer' ref={footerRef}>
						<p>Built with love by</p>

						<svg width='30' height='24' viewBox='0 0 30 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
							<path
								d='M29.8164 6.92237C29.5931 3.15367 26.4409 -0.191084 21.757 0.0279612C18.0162 0.203197 15.5454 3.80034 15.5454 3.80034C15.5454 3.80034 13.0845 0.196697 9.34347 0.0112855C4.66071 -0.219913 1.49883 3.11636 1.26622 6.8845C1.03586 10.6083 3.65395 13.9711 5.76781 16.2571C8.6414 19.3647 12.9819 22.5291 15.5188 24C18.0595 22.5356 22.4087 19.3825 25.2905 16.2828C27.4106 14.0025 30.0372 10.647 29.8164 6.92237Z'
								fill='url(#paint0_linear_112_1305)'
							/>
							<path
								style={{ mixBlendMode: 'overlay' }}
								d='M28.5643 6.92237C28.341 3.15367 25.1887 -0.191084 20.5048 0.0279612C16.7641 0.203197 14.2933 3.80034 14.2933 3.80034C14.2933 3.80034 11.8323 0.196697 8.09133 0.0112855C3.40857 -0.219913 0.246691 3.11636 0.0140791 6.8845C-0.216272 10.6083 2.40181 13.9711 4.51567 16.2571C7.38926 19.3647 11.7297 22.5291 14.2667 24C16.8074 22.5356 21.1566 19.3825 24.0384 16.2828C26.1585 14.0025 28.785 10.647 28.5643 6.92237Z'
								fill='url(#paint1_linear_112_1305)'
							/>
							<defs>
								<linearGradient
									id='paint0_linear_112_1305'
									x1='20.0408'
									y1='-4.518'
									x2='6.37661'
									y2='31.7776'
									gradientUnits='userSpaceOnUse'
								>
									<stop stopColor='#FFDADA' />
									<stop offset='0.93' stopColor='#FF192C' />
									<stop offset='1' stopColor='#FF0C20' />
								</linearGradient>
								<linearGradient
									id='paint1_linear_112_1305'
									x1='3.07647'
									y1='21.3706'
									x2='23.0294'
									y2='-2.78288'
									gradientUnits='userSpaceOnUse'
								>
									<stop stopColor='#D0A440' />
									<stop offset='0.21' stopColor='#FFF690' />
									<stop offset='0.57' stopColor='#C6932F' />
									<stop offset='0.67' stopColor='#B17D1E' />
									<stop offset='0.82' stopColor='#895500' />
									<stop offset='0.84' stopColor='#905D06' />
									<stop offset='0.87' stopColor='#A57318' />
									<stop offset='0.9' stopColor='#C79636' />
									<stop offset='0.92' stopColor='#DCAD49' />
									<stop offset='1' stopColor='#FBF09C' />
								</linearGradient>
							</defs>
						</svg>

						<a href='https://nlwc.church'>NLWC Publicity</a>
					</div>
				</CSSTransition>
			</div>
		</div>
	)
}

export default Menu
